import { FC, useRef } from "react";
import { SchemaItem } from "@data-root/types";
import { View } from "@data-root/react";
import { SchemaItemProps, useField } from "@data-root/react";
import { Skeleton, Typography } from "antd";

const { Title, Text } = Typography;

export const DetailItem: FC<SchemaItemProps<SchemaItem>> = ({ item }) => {
  // const { options } = useContext(InlineContext)!;
  // const { focusedItemId: _focusedItemId } = options || {};
  // const [focusedItemId] = useState(_focusedItemId);

  const ref = useRef(null);

  const { loaded, name, show, displayValue } = useField(item);

  if (!show) return null;

  return (
    <View ref={ref} style={{ width: "100%" }}>
      <Title level={5}>{name}</Title>

      <Skeleton active loading={!loaded} paragraph={false}>
        <Text>{displayValue}</Text>
      </Skeleton>
    </View>
  );
};
